'use client';

import { useSessionStore } from '@insta-club/state';
import { separator } from '@insta-club/utilities';
import { Toman, WalletIcon } from 'src/libs/components/icons';

function WalletBalance() {
    const walletBalance = useSessionStore((state) => state.session?.balance);

    return (
        <div className='bg-primary-500 mb-4 space-y-2.5 rounded-2xl px-4 py-6 text-gray-50'>
            <div className='flex items-center space-x-2'>
                <WalletIcon />
                <span className='text-sm font-medium'>موجودی حساب</span>
            </div>
            <div className='flex items-center text-[32px] font-semibold'>
                <span>{separator(walletBalance ?? 0)}</span> <Toman />
            </div>
        </div>
    );
}

export default WalletBalance;

